var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-device-wrap" },
    [
      _vm.hasData
        ? _c("Doughnut", {
            attrs: { "chart-options": _vm.options, "chart-data": _vm.chartData }
          })
        : _c("div", { staticClass: "ctm-no-data" }, [
            _vm._v("No device data yet")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }